import React from 'react'
import "./product.css"
// importing the Components
import Banner from '../Products/Banner'
import ProductLinks from '../Products/ProductLinks'
import FlashSale from '../Products/FlashSale'
import DarazMall from '../DarazMall/DarazMall'
import Categories from '../DropDown/Categories'
import {datas} from "../DropDown/categoriesdata"
import { datazproducts } from "../DarazMall/datazproducts";
import ForUs from '../DarazMall/ForUs'

function Products() {

    

  return (
    <div className="containers">
      <div className="products-containers">
        <div className="daraz-banner">
          <Banner />
        </div>
        <div className="product-links">
          <ProductLinks />
        </div>

        <div className="product-title">
          <h3>Flash Sale</h3>
          <FlashSale />
        </div>

        <div className="product-title">
          <DarazMall />
        </div>

        <div className="product-title">
          <h3>Categories</h3>
          <Categories data={datas} />
        </div>

        <div className="product-title">
          <h3>Just For You </h3>
          <ForUs darazproduct={datazproducts} />
        </div>

        <div className="load-more">
          <h3>Load More</h3>
        </div>
      </div>
    </div>
  );
}

export default Products